import React from 'react'
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {defaultInputStyle} from '../../utils'

import useStyles from "./styles";

const SelectBox = ({value, onChange, name, options, style, maxHeight=400}) => {
    const classes = useStyles();
    return <Select
        variant="outlined"
        value={value}
        onChange={onChange}
        onBlur={null}
        name={name}
        className={classes.root}
        style={style || defaultInputStyle}
        MenuProps={ {PaperProps:{style:{maxHeight}}} }
    >
        {options.length > 0 && options.map((option, i) => {
            let label;
            let value;
            if (['string', 'number'].includes(typeof option)) {
                label = option;
                value = option;
            } else {
                label = option.label;
                value = option.value;
            }
            return <MenuItem key={i} value={value}>{label}</MenuItem>;
        })}
    </Select>
}
export default SelectBox;